module.exports = __webpack_public_path__ + "static/media/mathias-adam-327287-unsplash.08ced648.jpg";